import React from 'react'
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";


const HoneyNav = ({nextPage, prevPage, showPage, formPage}) => {
    return (
        <div className="contain" id="app-nav">
            <div id="honey-nav-wrap">
                <button type="button" aria-label="Back to Form" className="back" onClick={formPage}>
                    <FaChevronLeft /><span>BACK</span>
                </button>
                <nav role="navigation" className="page-nav">
                <button type="button" aria-label="previous" onClick={prevPage}><FaChevronLeft  /></button><span>{showPage} of 4</span><button type="button" aria-label="next" onClick={nextPage}><FaChevronRight onClick={nextPage} /></button>
                </nav>
            </div>
        </div>
    )
}

export default HoneyNav
